const cartActions = {

  changeEvent (context, cart) {
    context.commit('changeEvent', cart)
  }

}

export { cartActions }
